
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/service-notary-certification",
      function () {
        return require("private-next-pages/service-notary-certification.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/service-notary-certification"])
      });
    }
  